import PeriodType from "@/models/Shared/PeriodType";
import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";
import Amount from "@/models/Shared/Amount";
import FundingWindowTriggerType from "@/models/Products/ProductSettings/DefaultSettings/FixedTerm/FundingWindowTriggerType";

export default class DepositInstantAccessSettings extends BaseProductSettings {
    fundingWindowPeriodType: PeriodType = PeriodType.Day;
    fundingWindowPeriodValue: number = 14;
    fundingWindowTriggerType: FundingWindowTriggerType = FundingWindowTriggerType.FirstDeposit;
    initialDepositWindowPeriodType: PeriodType = PeriodType.Day;
    initialDepositWindowPeriodValue: number = 14;
    maximumBalance: Amount = new Amount();
    minimumBalance: Amount = new Amount();
}